import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import "./App.css";

import Header from "./components/Header";
import Landing from "./components/Landing";
import About from "./components/About";
import DevLog from "./components/DevLog";
import DevLogList from "./components/DevLogList";
// import Footer from "./components/Footer";
// import Home from "./components/Home";
import Scroll from "./components/Scroll";

class App extends React.Component {
  render() {
    return (
      <Router>
        <div>
          <Header />

          <Scroll />
          <Switch>
            <Route path="/" exact>
              <Landing id=" " />
              <DevLogList id="devlogs" path="/" />
              <About id="about" />
            </Route>
            <Route path="/devlogs" exact component={DevLogList}></Route>
            <Route path="/devlog/:id" exact component={DevLog}></Route>
          </Switch>
          {/* <Footer /> */}
        </div>
      </Router>
    );
  }
}

export default App;
